import { defineStore } from "pinia";
// import http from "@/http";
import http from "@/http";
// import httpMap from "@/httpMap";
import store from "@/store/index";
// import { throttle } from "lodash-es";
import 'leaflet-rotatedmarker';
import L from 'leaflet';
import "leaflet/dist/leaflet.css";
import { useOrderStatus } from "@/composables/useOrderStatus";
import {toast} from "vue3-toastify";
import { useOrdersStore } from '@/store/orders';

const { getStatusText } = useOrderStatus();

export const useMapStore = defineStore("map", {
  state: () => ({
    devices: [],
    messages: [],
    user: null,
    throttledFetchAllFn: null,
    normalizedDeviceMap: new Map(),
    markerObject: null,
    markerFinish: null,
    markerLoading: null,
    finishIcon: L.icon({
      iconUrl: '/img/icons/finish_flag.png',
      iconSize: [25, 25],
      iconAnchor: [12, 25],
      popupAnchor: [0, -25],
    }),
    loadingIcon: L.icon({
      iconUrl: '/img/icons/plant-icon.png',
      iconSize: [25, 25],
      iconAnchor: [12, 25],
      popupAnchor: [0, -25],
    }),
    routePolyline: null,
    allJsonLayers: [],
  }),

  getters: {
    // pushesCount: (state) => state.filteredItems.length,
  },

  actions: {
    // async login() {
    //   try {
    //     const response = await httpMap.post(
    //         "api/login?simple=true",
    //             {
    //               login: "IVMS",
    //               password: "aywo6Cu!",
    //             },
    //     );
    //
    //     // Cookies lifetime set to 1 month
    //     const now = new Date();
    //     const exp = new Date(
    //         now.getFullYear(),
    //         now.getMonth(),
    //         now.getDate() + 30
    //     );
    //
    //     // Set roles in localStorage
    //     localStorage.setItem("roles_map", JSON.stringify(response.data.roles));
    //
    //     // Store PHPSESSID in localStorage for API calls
    //     localStorage.setItem("token_map", response.data.PHPSESSID);
    //
    //     // Set user data cookies
    //     if (response.data) {
    //       const userdata = {
    //         id: parseInt(String(response.data.id)),
    //         email: response.data.email,
    //         username: response.data.username,
    //       };
    //
    //       document.cookie = `user_data=${JSON.stringify(
    //           userdata
    //       )}; path=/; expires=${exp.toUTCString()}; samesite=strict; secure`;
    //     }
    //
    //     // Set user role cookie
    //     let userRole = "USER";
    //     response.data.roles.forEach((role) => {
    //       if (role === "ROLE_SUPER_ADMIN") {
    //         userRole = "SUPER_ADMIN";
    //       }
    //       if (role === "ROLE_ADMIN") {
    //         userRole = "ADMIN";
    //       }
    //     });
    //
    //     document.cookie = `user_role=${userRole}; path=/; expires=${exp.toUTCString()}; samesite=strict; secure`;
    //     document.cookie = `user_name=IVMS; path=/; expires=${exp.toUTCString()}; samesite=strict`;
    //     document.cookie = `last_login_date_formated=${
    //         response.data.last_login_date_formated
    //     }; path=/; expires=${exp.toUTCString()}; samesite=strict; secure`;
    //
    //     // Set PHPSESSID cookie - this is the most important one for authentication
    //     if (response.data.PHPSESSID) {
    //       document.cookie = `PHPSESSID=${
    //           response.data.PHPSESSID
    //       }; path=/; expires=${exp.toUTCString()}; samesite=none; secure`;
    //     }
    //
    //     // Set user account id cookie
    //     if (response.data.account && response.data.account[0] && response.data.account[0].id) {
    //       document.cookie = `user_account_id=${
    //           response.data.account[0].id
    //       }; path=/; expires=${exp.toUTCString()}; samesite=strict; secure`;
    //     }
    //
    //     this.user = {
    //       ...response.data,
    //       id: String(response.data.id),
    //     };
    //
    //     return response;
    //   } catch (error) {
    //     console.error("Login error:", error);
    //     return {
    //       status: "failed",
    //       error: error.message,
    //       error_text: "An error occurred during login",
    //     };
    //   }
    // },
    //
    // async fetchDevices() {
    //   this.loading = true;
    //   this.error = null;
    //
    //   try {
    //     const response = await httpMap.get("api/object/list-multiple/69");
    //
    //     if (response.status === 200 && response.data) {
    //       this.devices = response.data;
    //       this.buildDeviceIndex();
    //     }
    //   } catch (error) {
    //     this.error = error.message || "Ошибка при загрузке девайсов";
    //     console.error("Error fetching devices:", error);
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    //
    // async fetchRecentMessages() {
    //   this.loading = true;
    //   this.error = null;
    //
    //   try {
    //     const response = await httpMap.get("api/message/list/recent-multiple/69");
    //
    //     if (response.status === 200 && response.data) {
    //       this.messages = response.data;
    //     }
    //   } catch (error) {
    //     this.error = error.message || "Ошибка при загрузке сообщений";
    //     console.error("Error fetching messages:", error);
    //   } finally {
    //     this.loading = false;
    //   }
    // },

    // // Создаем троттлинг функцию для обновления данных
    // throttledFetchAll() {
    //   this.throttledFetchAllFn = throttle(
    //       async function(forceRefresh = false) {
    //         // Запускаем запросы параллельно
    //         return Promise.all([
    //           this.fetchDevices(forceRefresh),
    //           this.fetchRecentMessages(forceRefresh),
    //         ]);
    //       },
    //       20000,
    //       { leading: true, trailing: false }
    //   )
    // },
    //
    // normalizeTruckNumber(truckNumber) {
    //   return truckNumber ? truckNumber.toUpperCase().replace(/\s/g, '') : '';
    // },
    //
    // buildDeviceIndex() {
    //   this.normalizedDeviceMap.clear();
    //
    //   if (!this.devices || typeof this.devices !== 'object') return;
    //
    //   for (const deviceId in this.devices) {
    //     const device = this.devices[deviceId];
    //     if (device && device.name_custom) {
    //       const normalized = this.normalizeTruckNumber(device.name_custom);
    //       this.normalizedDeviceMap.set(normalized, device);
    //     }
    //   }
    // },
    //
    // findDeviceByTruckNumber(truckNumber) {
    //   const normalized = this.normalizeTruckNumber(truckNumber);
    //   return this.normalizedDeviceMap.get(normalized) || null;
    // },

    async calculateRoute(order) {
      this.loading = true;
      this.error = null;

      try {
        const response = await http.get(`/api/dispatcher/orders/${order.name}`);

        if (response.status === 200 && response.data) {

          const responseData = response.data;

          // TODO: для теста УДАЛИТЬ
          // const responseData = {
          //   "estimatedDuration": "2ч 49м",
          //   "estimatedDistance": "126",
          //   "estimatedDeliveryDate": "02-08-2025 00:46:59 GMT+3",
          //   "routeGeometry": "{fsrI_uyeFAqBD{A?aABgCIe@uBwD@SH[Zi@HYTk@FITVPWLY\\q@nAqBT]l@a@Z@`@`@nNtVdClEfEpHb@lAHf@?`@EXITSPYBcCQOIIME[B_B^cCpA{G`BoIR_@LOLCN@LHJPFTBX@^E`@G^uBrHKRMLO@U@[Ko@iAyKsRoFoJmFiJk@cAc@w@wFyJgCqEyEeI{AgCEIiBmCgDwEkD_EsBqBoC}BeEuCmBiAi@YaCkAsBy@wAk@yBq@qBg@gAO{AW{Dc@iDQe@A{BEwCAqDRyCZyCf@sEfAs`@jKcv@`SkVtHoDbAsGdByMpDqBf@cF~@oEp@mDZiE\\oDHkDAkEKyDWiBOwAQkAUkASKCoB_@wA]eAWa@MwBo@eC}@WKwCiAeRkI}BcAcBu@{IuDiBy@yB_AkF}BmB{@]MgAe@}BaAoH}CcCcAsCy@mCo@{Cc@qEa@}UyAePaA}b@iCoDUsLs@_@CuDUuHe@sAIoJo@yV}AqBKwEWgHQq@A{BCyCEuBC}HOM?mFGsCEcBE{CK{GQuACeEK_EE{@AqFM]AmFWg@AO?wEIe@?sAAwAEmBEaCGoGMmBEwP[aECiCKeBEYA_BEcISiA?_E?eH\\sFXg@BmLp@K?qAHsAHM?iOz@iEN}[vAcZxAgEZaNx@gAHkTpA_Jj@qG^mLj@kF^}@DgAFs@@e@@U@cB@{@AmA?qCB_FRaLl@u@Bg@Dk@ByAHcNr@iBLsEZeEb@uCZqGl@]BwBTK@wB^kARsA`@iDfA}Bz@uBfA}BrAwClBqB|AgBzAoAlAQNsArAyAbByBpCuAjBe@p@aBjCqBnDm@hAyArCa@`AiBhEuBzEk@rAgAjCaErJgYzq@wJxU}d@thAeMnZyVhm@gEdKu^n|@ua@jbAiBhE_e@zhAcEzJ}^`}@gI~RoIjSsAdD_@x@q@bBcC|FuApDcAvCy@fCyA|D{@~BkAvCq@~AKXqB~EMViDfIsE|KqCdHiCfGwCfHwJbU{@tBkB~EoAnDwA~DUp@_C`H{@jCkAnDgAzDiAjE{@~DmAhGaA~Fw@|FYjC[pCi@xGe@`IYxGK|EEzAQ|LQfTAbAGdFAdCAd@IzHM~MQhXGhIGxFG~G?\\UzPE~DCxB]rSQhIUdJM|Ec@zMIhCm@pPk@rMs@~Nu@bOw@xMw@vMSnC_BpScAzLeAxLkA~Ku@nH[xCIj@wArMyBrQaCzQqCzRgCpPiCtPqD~R[`Bg@tCaN`u@]lBg@nC]hBcCtMO|@iChNa@zBq@rDo@jEk@dEMfAYdCOxASjBMdBUlCMlBQfCYvFEt@QpFQhHItFAtE@lE?H@jAHhHNjGV~Gp@lM@`@r@jNxGvqAZrGV`FtC`i@NbDdAbT@L^zGn@nM\\hFX|D\\vDZ`Dd@~Dr@xFh@xDp@vDtA`HbArErAjFvA`FzCxJz@~BbAvCzHdUtUrr@rEbNL\\bEzL~EbOf@vCVrAJ|@Dn@Bp@?n@Af@Ev@I`BQzBUzBWzAOp@Sn@e@x@[^a@\\iBlAc@\\QNONa@d@c@l@IPQ\\iA|BUf@Wb@QXYXYT]P]J]BW?YA_@EkDY]C]?YB_@HSHUL]ZW^Yd@O`@]jA]rAqAtFgAvEsBnIeAfEWv@]z@Uf@e@v@o@lAk@hA{@|Ao@nAk@lAm@pAmFbNqLtWwLdWuLtW}ElKwHhPsCdGyC`GuAbCiAfBiBbCeAhAy@x@mAhAqAdAoA|@sAv@sAp@qAh@uAf@iCn@kP~DcVxFgLlCeK`CoCp@k@N]He@J_AVk@LgAXsBz@{Bj@K@GBaCj@cEn@gAPc@Jq@P}D~@qD`AqBp@qBx@kCrAiCjBqBfBqBtBmAvAgBdCwA~B}CzFoQl]mU`d@eCvEcBpD}AnDyAdEu@hCoAvEqAvG}@|Fq@nFe@nEsCbYsBnTm@dGiB`RIv@sDj_@k@|G_@lFUdGG~E@`ELpERfEV|Ch@zEXpBp@jDjAxEhApDpAdDtDjHxEpJlAhDfAvDbAvEn@`Eh@|E\\vEN`EHvC@tEC`CEhCQ|DSvC]lD_@pCYhBe@bCy@rD{CvKaCbHoB~FeB`FaDpI_FnNgMn^sDzKkDtJs@rBQh@gCvHiBlGy@vCq@~BiDtM}AjHeBvIiB~J_CtM_BbIsAbGgAtEoA|E{@~C_CtHmBzFaClGuCbH_BpDmCxFoCvFqErIcElHkB`DqTf^cCzDmFpIaDzE{CdEeC~CkDxDmDlDwDfD_EzCeHhFeFjE[Xa@\\cEtDeEpDcEfDcKjIwPhNqEpD{MvKeCrByZvV{BhBqAbAoJ~Hwb@n]_KlIUPkDrCyGtFyAlAuGrFkKrIqBzA{AdAyBvAiCzAgCpAoClAeDrAeCx@oCx@cDt@aJfBwHxAeKfB_Cb@oCj@eB`@wGvAgCr@cDbAmBr@oCjAqExBmBdAyCjBcD|BuDxCuChCkDjDyCdDoDnEeCjDuChEuCvEgDfGqCtFgC|F{CpHiBzEcBdEgC|GkKdXiUpl@{B~FiBxEm\\x{@wHlRwD~HwDbH}EfIuB`DuBjCeExFqEdFsEjEoH`GsHzEiD|ByDtCkFxDkDlCsHzGeEdFw@`AeKdNiD|FS\\qEpIwCnGeE~JwF~OgGlTgBrHmA`GcD|P_A|FqCrT{AlP{@xJoDta@QfCUfCs@nJgCz\\aDv_@oEvi@sB|R_CxQiB|KqAbHsEvSeGtTcEtLoD~IuA~CcEzIuFfKeFhIgHpJaI`JwChCqFpEaFvDkQfKgItEkGlD}MfIaN|H_GlD_CzAmBzAsEpE_E|EgBhCcEjH}BlEeC`G}CtJ{ChLsBhKqA~HiArI_AbKm@bM]vLMzPJbHFfEL`ELrDr@zKrAzOlBbZh@xId@lLNfQBvMCfQEtI_@nNiAtSw@fLcBjPoBfQoA`I{@pF}CzQgDbWgBpSyB|\\o@lSWr_@LlMPzJv@pU~Bx]zBvTrBxPrBpRt@lJ~@bOT~E\\pJb@pR?`AF`UQ|Oa@dPgAbWwAnWwA`VmAlOmC|Z{AxUk@rHaC`WuAfLcC|OmCfN}DhQoC|JiFbQaQrc@eLxZwFdNeDzIyGpQcBhFuEjPq@pC}BnJaC|LaBvK_F``@qFdc@c@nDaDvUwCrOcF~SeC`JgBvFkBjFoBnFkG|NoEjI}Qj[mR`ZohAffBq|@fuA{JlQqJhSeGrOcGzQ}EtPuEhRcUhbA}SzaAsFhUkNrc@Od@oStl@cGxOyHbQeJpRmJdRsKvPyKhPaEvFyIhKuBdC{MxN{FfFeJjIkAbAkSpNcAr@_sCroB_X`RmNxKWPyGvDiLnL{A`BwQbV{DvFiWve@cCjEU\\{Yfh@iK`TyJrV_CjGyHjXqBvI_F`TkJpi@kDxS_AjFk@xCsB`JmGhVaH~UyIxUiGjNuAxCg@bAaI~OiIfMyKdOyLzMmKjKiGzEuHjFeIlFwBtAaGzDuGhEiiAfu@a@Xos@he@aFlD_EvCcFfEsDzD_F|FcDjEqQdUmRnWgTnYkAzA{e@dp@cl@tu@UZ}H~JqQzTaXfZwU`TgNlL}D|Csf@j\\eCtAeB|@_JrEoKdFgl@bYuJ~EcnAtl@eBx@gAf@aA`@_P`H_O`Gi@RcPjF}NjEkXzFmXvCsQ~AsNl@mOPmf@UyA?qAAyFAgFCiGAqWPsLd@iCRaOlB_WxEcWxHqYnLyQbJi[pS{AjAkTrRsFlFgOjPqLjOim@~v@yQxR{RdPeShM}OvHYLuZxKip@xUyAf@ir@zTwShIio@`WwnAtj@_MbF}f@pSmb@~SyKhGga@tWwN|I}z@zi@mOtJwO~Je`@zV{LhIgFrDcGvFcG~F_G|H{HtLgIpNaLnXcy@h}Bc^fbAe`Av{B}@tBiPxc@}j@r{B}Ozh@}EpL[p@_AvB{GvOaD|GwEdJ}I~PwRx_@iG~LiA~B}DvIkEpKyBtF{CpIeDxJaSzn@_Qri@uNxd@_HlTY|@qEtNqR`k@eN``@ij@`}AcLhZ{E`KaGlK{K~OoHrI}A~A{BvByGpFmSrLqjB`cA_@L_@F_@D_@?_@A_@G]K_@O]S]W[[Y_@Yc@Yi@Yk@Uq@Ss@Qw@Os@K{@I_AG}@C}@A_A?_AB_AD}@H}@H{@Ly@Pw@xCwNjFeQ`BgJlA_HbEm\\nCmNLu@Hw@Fy@@{@Ay@C{@Iw@Mw@Oq@So@Wi@Yc@gHcIaByA]W_@M_@Ia@A_@D_@J_@R[X[^Yd@Uj@Sn@Qr@Kt@Ix@Ex@u@nWg@bLe@hFk@xFg@`CoEbUc@vBsBnKELuA`HsEnUa@lBoE|T{Odx@eDjPKh@w@~DCLyE~UaG~YwBvKCFyBhL{B|KYvAaFtVIb@aBhIsAxGCJeMtn@eDtPgDzPcNpr@eBzIkHn^wC|NoChN}CvOeNzr@k@fCoBbKGVs@pD_A~E}@tE_GfZsPnz@S`AOp@iCtMwCfOmCtM}A~HmBtJsCxNSbA_@hB}@nE[|AwClOsAvGsApGeEzSyArHm@xCWvA_AvEQz@cAnFa@rBYrA}AhIcBlIw@~DoClNyBtKm@hDs@xEe@bD[`C_@dDo@hGi@tGQdC]nHW`F[nKCjBIrPHfO@tCB`DF|LDvPNzj@BrM?dBH`XN|g@@tC@hH?rCBnEFjW@hHVtv@DlJ@bF@r@JfX@`CDpNL`^BzHB`JDtL@xC@\\?dG?T@vEAnX?bCBbILlXFfXT|v@Nl]B|N@rEBvCD|GA|D@j@R~p@BlMNhm@@tC?P@|X?~BFrUGjHAT]dMKtCU`Fi@bIWfDQpB}Ejd@s@vGmEna@_BbOuB`SkD|[UvBm@xFgAzJw@pHgBfPaH|o@Ix@mAlKiHzq@u@~GgBlPYpC}E~c@}@nIeBfPyClYqCfYeAtJgB`PQ|Ai@pDg@nD_@zBy@|EoEpS}@xDuBvHcBvFgB~E{A|DgB`EgFrJqRh^aB`DkEhIm_@jt@oBlDsDdHqDzGeNnW{BbE}GvLeF~IiArBgBhDwGdMwAnCcE|H_ClEyCzF}@dBa@t@qJvQqG~LcGhLkD|G_DpGcAtBw@xA}@~Aq@bAgClD[^sA~AaHpHcB|AoAdAo@j@c@XoBvA_@TqCzA}B~@eCv@{Dz@k\\lEsJrAuNhBU@cBP{@Pq@P{HtBgCh@sAVeBTcCVoBVgCZC@kDb@q@H__@zEiMbBs@HcQ~BwAP}L`BiMnByBZaH`AaANm@HcAN_D\\qANqAToA\\oAb@oAh@mAn@kAt@kA|@iA`AgAhAeAlAcArA_AxA_A|Aq@pAq@pAk@rAi@tAi@vAe@zAe@zAm@zBk@|Bi@`CMv@WvAUxAUxASzASzAQzAQ|AO|AM|AM|AOjB_BbRm@hH]hEw@jKa@vEu@xI}BfXANg@tFMxA]dEI~@QxBeAbMc@rFuA~O?DoEth@_@fE]|DEd@g@xFiArMeB|SoIpbAI~@u@`I}@tHo@bGYfDEh@]dFw@dNWjDs@jIa@vEGr@s@rIEf@YzCYdCi@zEi@rEc@|EWxCQxB_AxOUdDC`@g@fGaEzd@wBtVwCt^kFxo@}@nKK~@cBxOu@rHg@dHm@pIo@nKQ~BCZ]`EcBjSShCyBbWeAnLiA`Km@dGm@hHe@xFq@dLu@pKQnBAH]|DqBlVgIlbAqC`\\}@`KEj@y@~IgAfKk@jFg@bH]hEa@lGcAzOoA~NI`AQrBi@vGYbDeFdn@CV{@hKyAfQqBtV}@|KKnAa@~EWbDe@pF[pDq@fImNndBaBpRkAhMoAbKiBtMWlBg@tD{BjOyAfIqAvGuA~GaAhE}DfO}DhN{DnLkBfFiCbHeDzHsFzLoF|JuCfFoCdEeGhJiA~AcF|GkA`BwHhK{GfJiCdEgC|DmB|CmAfBk@~@uBpDy@xAw@vAiBtDqBvCOVQZQTQRSTYPYN[PuIpB[B[D[?[C[IYMYSYWU[Ua@Sc@Qg@Oi@Km@[eCwAaPkCw[OoAQcA_@qAOa@Qa@Q_@S[S[UWUSUSWOWKWIYEWCY?W@YDWHWHWNWPURUTSXS\\S\\O^qFzMyLtY_LtYsFrMe@jAe@nA_@rA]pASdASdAQhAOhAKjAKlAIlAGlACnACnA?nA?nABnADlAFnAHlAHjALjANhAxAhKPhAJjAJjAHlADlABnA?lA?nACnAElAIlAIjAMjAOhAQfASdAWbAGTGTIVGRITITIRyEpMeQnb@O`@{GnPsDtJyDvKqFbQeHpWkGhXcOrt@k_@hgBaHd\\yMto@_K~e@wz@~rDMf@iMnj@ue@pqBeXrmAeFbVkAjF}`@bmBmo@h{CMj@eKtf@ur@xaDwKzf@Mh@gi@ncCMn@m^naBeCnLiCxNsJzm@y@~EqBrM_Op`AIn@yKjr@Mt@wVp`B_CzNqCjNkC~KaArDe@~A_A~C_AbDss@x}BaQvj@wAlEgl@hlBSn@{IjYkDhKeExKwFtLoUpd@o@nAkgA~wBaJfQYh@c[bn@wFxKwo@bqAUd@gJzRa_AroBSd@_KhTeAzBgv@l`BWf@}AzCsDvGsEbH}ExG}E|FeFdFsFrEoF~DcIzEabA|f@_eAbi@a@Ru]vR_iA`o@_dBf`AqBtA_FvDc@`@}IxIqIbKuE~GoEnHkEfI}DpImCtGkCdHiG|RwYncA}Wx~@_GhS{BtIaNjd@mA|DeNd_@oCtHiD`IqK~TwJdRaKrPuAnB_JrMuHnJwG~HuHbIwRtQWTgPnNkQnOaR`PaHhHcHfI}E~G{E~GoEnHmFpJSb@kHnOcFvLuGpQeJn[iFrTaDxO_FxY}@fGiBjOuAzLi@zFgC|[Gp@kO`nBkBfU}@lLs@lJy@fKkA|JkArJsAnJyAxIcDdPsDpOwFbReB`Fa@nAuDzJoD|HiDdHuMpTmK~LwKrKi{Al{AkXlX{QzQwJpJ_Q|QoQxScGlH]f@{GfJgHbKuPlW{HtMmFjJmMtV{BpEgAbCiDrG}C`HgErJSb@kPpa@mPza@w^v~@eOt_@aGjPuF`PsDhLaDvKkI|YoF`TkEdRuE~SgEhT}Jjm@wAvJeFz_@{CxXuChYWpCiBhViBjXmBr\\iBj^Ep@i@hNwA`Zu@pPiBf`@cF~eAc@xIsAvZEp@WdG{A~SyAjR{CxYiGva@qB`LoBxJaCvK}BtJ_EjOmEhOoElNmFpNkJnTaGzL}GrLcSj[w@nAod@~r@uDvFU^gF`IwPnYoIhOaInO}W~j@_ElJQb@cInRmI|SiDdJoCpHaElLgCnHcGzQ}Tnv@qOdm@wq@rmCOh@uc@zfBMf@sLne@yTt|@q@tCuQbw@eNlm@kNlm@Mh@mv@dgDwRnz@On@sW~iA_K|b@qGbWyGvVmKz]iLv]eB`FQ`@iFjNmFdNw@pB_ExJ_@`Au@`BgNxZwN|YwNvWoO|ViF~HoAlB_Xt^yZf^cZrYwS|PoJbH]V{HzEmXvPgDhBwDnBcVpKuQdG}NlEcMlD}R|DsAV}cAdRuN|Csm@pOwCx@oBn@aA\\uhAj^kbAb\\oBj@uQfFoRzEsQlDoRhDog@rIuARyEv@wTnE]HsPtD{a@`Loc@rNifAv^qBr@}@Zw@VeMjD}LnCcIxA_KlAan@hFsh@vDaJt@}c@fDeGf@}Gv@sI`B}GxAiKbDmE|A{FjCmGvCwHpEgInF_IfGiOpMkKrJWTg\\~Y_\\nYq_@f\\yKpJ_BtAqFzEu_@b]uD~Cq\\z[mApAkRlSySlVeSnWW\\_P~TuGrJ{GdKcSp\\qRj]sQx]Sb@yKtUoJ|SsLzX}HfS_I~SqGfQoG`RgKp[cJdZqI~YyBfIMf@yGjWuG`XmHt[kIj_@Oh@gKbf@mE`SgErQoErQgF`RqJ`\\Of@uAfEiIrVmG`Qi@rAkIbTgIdR{IrRsGhMeBfDcPzYkAnBeE`HcHpKoGnJ_G`IwGtIsGzHaQnRoApAyH`IuJvIcKpImIpGkIzFsIxFgJhFYNeMvGkM|Fww@d[qj@zTuh@dTsIlDiu@lZeu@`\\YLi}@~`@u}@|`@y|@n`@_GlC{GfDkG`DmHfEcI|EuIzFqKxHg@^gEjD{GtF_I`HuG`GqHpHs@t@_GlGmSvUoA|AeErFwD|E{MpRaNzSiIdNiI|N}I`QcJ|QaRjb@iGlOmGtPQd@_Ttn@wHxVqHjXqH|YyHb\\qEdTkErTkI~d@sEfYIl@gBzKqJtn@uDjVgExV}H~a@{Ija@aAbEaBxGwE`RkKv_@mHlVeIfVuGrQkHfRmJ~TmD|HeHdPgBhD{JnRyJ~PqQ|YaRj[qo@vfAmo@`gAkp@jhAkSj^uWxe@_@r@gAnBqc@dz@{o@fkA{o@tlAwg@p_AwJnQ{JbQsJlPyJ|OU\\sElHiOjUkLxPuLrP_MrPiMhPe\\l`@_Z~[eUjUuU`UiRjPkStPWPaSlOea@pZmA|@qHxFiq@|g@cChB_a@jZoQbOi@d@aJtIYXgDnDkKrLmAzAaMbP{C~D_G|IoDtFyDnGU\\iBbDeD`GaK|RmKbTyz@ldBwErJyEhKyMtZiJrUcKtXyHpUgHhUcA|CsApE}Kba@y[hlAkC`KqGjVoi@fqB{@hDe}@~jDcGlSeCzHsC~H}HnRqIpQeErHuExHwE`HuElGgFhGyGjHsH`HmIvGoLnIuMlLiFnF{EzFyGpIiHhKqD`GqDrGoIdQoVxk@}BfFsM|Zw@jBwEvKwErJ{E~IwF~IaClDuH`JcIbImI|GwTbQoNdLau@`m@q`@j[_Q~M{PnMqPrKwQpJsOrG{GhC_HvBoIfCuInB_ARa@HmB\\iKfB{f@dJmT`EmB\\kkAfT{FzAeFtAsNvEyMnFeGpCaFfCyIxEqJbGiIzF}ItGcMnKqF~EqFnF[ZkBnBiPtQoGhIyGxIgPhVgPbXcf@h}@kf@b}@kXbg@k@dAcIxOqPp`@_FrOmBfG{HbYcClLgCrMuC|OkCpQwBjPeBpO}AhPsAvOaQnxBkL`yA[zDaBfTwDff@mAlOc@tFcBpVkAb[}@ha@QxOKdP@jMBpPLfNVzOfAn^VbG`@xHn@fLtBzYbCjYjAnKrA|KrAfK~AbLlBpLfB|J|Hd`@vGhZpFpVfI|`@Lx@rC~Q|AzLbAjKrA`P`AfPj@jMd@lPVlOBlPOjSm@d[wDtkBcEpkB_@rQU|TCnQXl_A?tET`a@DrURjg@?rTo@z\\_Bn\\aAnMiApLwAbM{AvLmE`WcBjIaChKmC|JuCpJmCfIyD~J_I~PgJxOkFtHkFbHaN~PyKtNwKdPsGfL}@fB}HvQ{JhYiIj[mN`t@qFbXqBzIqCfK{DpMaErLkFdMmF`LiSl_@mS~^m\\rn@yPrZ}D|HgOdXsMrVkC~Ee`@ls@Ub@oNpWsPh\\yOv]qOx^wOb^a]vw@}[hz@kW~s@{AtESr@{Rpm@ea@xgAyD|M_CjI_KnZeJd[wAvEQn@qR`s@gG`Rc^p`A]~@yDzJcx@pxBmRhv@iAxF{@zDc@~B_D`SObA{A~MqHxu@eAtJi@fFiGbf@{Hzc@c@tBiBrHuAhFeLjc@mEjOmEvOaLf`@aEvM_IdUoAfDSf@{ElMk_@fw@cFrJ}BpEy@|AuOhZuBbE}A~CeHtN{EvJiGdMcRvUeBpBgQ|RiInL}ElIsGpMuKnX{EjOeDrMeDlN{E~WeFj\\aQ~|Awf@bbEkBpOeIxp@sBzNej@ptD{UrhBYvBsJxv@uBtPeGxa@a\\`cB}DfWcFv\\mFnXaD`MyDpOeIr[ud@blB_VhcAyLjk@eDnPsCfQcDjRuFj[eBnJeDdTuKdv@oBdOcDpXaBhMgIjw@wIbaAEt@mBzVmx@zjLKnAiQhfCgNztA{Lt|@}CfRUvAgNzw@cDpO}Jjc@eKjb@kUpx@wJd]}H~XkGbWwCxM_EtRyA~GuGl_@gGp_@oEv\\gDdZ{BtSKpAuDnb@s@vLkDdf@aFlw@iG~}@_Hl~@uGfq@mJhy@SbB}AhN_D`Y{I~v@kI~w@{J`iAqKdyAGr@sHheA_N`kByEjl@{CjXmDtWyR`tAqEx]yBxSqBdTkArO_AxOsBx`@IxAaBt[oAdVEx@iEzz@eGz}@kSvuBGt@mVfeCY`DiWrjC[xC{Id_AaEtf@eE~o@qCnk@eHtzAyFtmAE|@sa@~yIgH~pA}B`_@a@pFW~Dkc@thHiCje@}Cnh@IhA_@lHe@zHgArOcCl`@gCt`@i@lKe@|Kw@rW{@fYy@vd@M|GCz@}Axz@y@fWaAbWs[lxFG|@_HrnA_Nx`C}C`c@yCj^eBhRqBzRiFhe@_Hxg@uHjf@uFn\\Mr@aHb^kH~\\cI~\\uIx\\Qp@_HjVwFjRaJhXiHvSwPld@gBtEUp@eBvEy}@|cCc^zaA_[tx@eHfOe]tq@uXzd@eY~`@sVpZqPbR[ZcSdRm`@r[YT{v@~l@{v@rm@o@f@gDpCoFjEmIxGsAhAuJfHqAbAgDfC_F|DcAx@wG`FwUdRoF~Dke@z^wPhMc[pWae@l`@c@^sE|Dsh@rc@eNfLs^b[{n@vi@{ApAeDpC_W~ScShQcz@~s@ox@vp@_`@xZ_DdCqA~@aFrDaRhNsc@f^_eAhy@YRqN`LgvA`gAeKxGkKlFc@T[NkXjMgNtFuNnF}KbDwKjCaUtDgl@vE{TLiB@yCB{Qo@{N_AuVsCa@EqPmCiv@mRic@oK_YqGYGgk@yKyj@_Ka\\iFcQiCij@oHo_@wEq_@{DaJq@eEWoBMuOmAmHu@{S_B{SwAew@wDmNa@o@AsBCqKe@sQi@yX[ok@u@sg@Cgk@h@Y@qD@kRF_FLiGVmMpAyFx@wFlA_JdC}KvE{KxEuKhGiKlH{RtQoMhOgLhPsMzS_DxF_B`DWd@qFxKcT~c@sFzLcIzP_DzG}u@d_BsIfQaJxOwLzPgKjMkG`HiFfFeT~PqXpQk}@`m@{k@z_@aBhAef@v[i@\\yKrHcUjO}InG}IfHgQnPuPhPwb@tb@}WfWoWdWe_@f_@wW~VkFjFml@hl@g\\`\\cOtOiHjJiGnJk@`AeClEgEnIwC`G_KxUw`AlhC{N|_@_KbVgAhCkC|GgLnScIxMqOxSoIlJoF`GwXrVyXdVuEhEqKjJwGzF_a@x]ch@pd@gYrV_Y`WyJhIsJ~JkGjH_GnHsGnJeFvHaTx\\yT|]m@dAkHjLwH~McX~c@wUd^qUr^uk@n~@gl@p}@_CpDa@p@ubChwDsN`Tc@v@y~BnvDkFrIk@|@wEhHsCdEo@~@gLtNgK|JqHnF{GtEiLnGgMfFmJvC{bA~Nam@|IgIlAaJrAaKvAePbC}JxCcBp@wHjEqAt@iJlGgMjLgMlOaLxQ_FrJoJ`VeQbc@qN`^mBbFkFhNuGrRqEdPaEdQsExUgKdj@yK~m@qMzt@mMvt@{[djBsUxoAmAxGmEzUmU`~@ee@rlBu\\~rAm\\frAgGfSsGfSkKlXgLdWc\\nq@eAxBk[dp@wcArvBUb@qd@r`AscAzsBsCxFkDfHuN`ZgIjP}IjP_I~KeI|JiUbR}IbIcMhOsG`LkGpLkF~M{E~NgEtOmDxO{BrMsB~N_BzN{AhPwDj^{Ep[aC~LkCzLoGzU_DrIYv@iChHsDnIwDfI{FfKeI|LkJdMwP`Tq@z@yYna@uCdDsJrJuNpKwOvH_HlB}GhA_J|@gHJgYdAY@wu@nBi_DtIaDNkCF}GHoCN{Hb@eHz@mFx@e@NmA^kHfCwFhCgLnGgFrDeFrE{DbE_MhP{GvKgEhIeEvJeIdRUf@gh@zkAsOx]k@pAcdAlaCkBdEgPf_@sPf_@gc@p}@u@zAkHfOmUbf@eCtFcEjKa@dAeXxr@iDbJaN|]}JjWeIfS}GhPaCtFaCtFaCtFaCtFaCrFaCvFaCpFaCvFaCtFaCrFaCvFaCpFOZo@tAeA|BgCdFkC|EoCrEsCfEwCxDwCvD}CjD}CfDcDhCeDjCcDxBiDdC}C~B{AlAqAdAeDbCeDfCcD~BgDbCiD|BeDjCcDrCaD|C}CfD_DlDsCpDwCdEuC`EqCrEmC|EiC`FwEdKmBvDqAhDaAvCyB~FsBpGyAnE]pAiBzGgBbHcBfH{AtHwAxHyAhHsA~Hm@rEw@jGa@dDcApIc@pD[hDIp@o@dHq@xIm@|Ig@xIa@bIeAtT_@dJ[xI]xIa@dJa@|I[~Ia@|I_@jJ]`J_@bJa@dJ]tI[|GEbAEv@[bIYlH[zI]`Ja@|I]dJ_@~I]vIa@zI]`Ja@|I_@zI{@dSE`B]lIe@vJYdI]hIa@~I]xIc@`Jg@rIo@xIw@lIUbC{@hIk@zEiAjIkAhHoAnHuAlHUbAe@dCYvA}@hEeA|E]nAi@rBu@rCs@nCs@hCu@bCw@bCw@bCy@bC}@hC{@~B_A|B_A|B}@rBeA~By@pBgAvBcAnBeAnBeAlBeAfBiAhBiAdBiAbBkA`BiA|AoA|AkAvAmAvAmArAqArAmAjAsAlAmAfAuAlAyApAiAbAmAbAoAjAcCnBsBfBwBjBi@l@qAhAoAhAuAlAa@^YTUToAfAoAfAsAjAmAfAcDrCcDrCcDrCcDrCaAx@}ApAoAfAqAjAqAjAsAjAqAhAoAdAoAhAqAdAsAdAqA~@uA`AsAz@sAv@sAr@uAr@wAp@kDxAwAf@wAb@yAb@uA^oD`Au@Ta@LwAf@wAn@uAv@i@Zi@`@sAbAkAfAsApA_DfDqI`JuKnLm@j@{@z@}AfB_@l@{BlC}CrDeAlAuBzBiCjCmAnAk@j@]ZwAnAsAnAsAlAmAhAeA`AaA|@}@~@_AhAu@`Ao@|@e@p@g@x@o@fAS^c@x@o@pAk@tAe@lAq@dBi@`Ba@rA[fAYbAa@~Aa@fBe@|B]rB_@zBWjBYnBUjBUxBg@xF[~CUlBKbAQbAYpAu@xCoDpJy@nCeAnDiFjMgFjMoXvr@{GbQ_A|ByExLSd@{AbDuAzCiAlB]r@kApBiBpCmBjCoEdF{Ap@s@`@e@Tg@H_@AWE[K]UQQQQYk@KSO_@Oc@Mg@I]Ge@Kw@IeAIgBMeEOaFM{EMsEI{@E}DE}D?g@CsE?qE?mH?gE?mI?sB?sB?mA?{B?eA?qA?kVD}@Ba@Jk@H[Pk@La@f@{@L]L]\\iAV_AZsATkAX}APiALeA?]AY?KAICGEIECEAE?E?GJGNGXK^IZu@lDQr@aB~Ec@~AKd@EPE`@Gr@EpAAtB?tAFrAHnAArC@~@Ah@?lD?pB?vH?z@?zA?r@?lG?rH?^GbAGpA?H?T@lD?^@hL?p@M@E?yDZq@DeDV{BRyCTm@Dg@DyCR[B{BP?TDPFD"
          // }
          // order.last_msg_speed  = '57';
          // order.last_msg_sat  = '11';
          // order.iconAngle = 134;
          // order.iconSize = [24, 67];
          // order.iconAnchor = [12, 67];
          // order.iconUrl = "/img/icons/car_icon.png";

          useOrdersStore().setRouteData(order.name, {
              "estimatedDuration": responseData.estimatedDuration,
              "estimatedDistance": responseData.estimatedDistance,
              "estimatedDeliveryDate": responseData.estimatedDeliveryDate,
          });

          // удаляем все с карты
          this.allJsonLayers.forEach(layer => {
            if (store.map.hasLayer(layer)) {
              store.map.removeLayer(layer);
            }
          });
          this.allJsonLayers = [];


          // если есть телеметрия авто
          if (order.truck.number != null && order.truck.location != null) {
            let message = `${order.truck.number} Скорость: ${order.truck.speed} км/ч. Спутников: ${order.truck.satellites}\nЗаказ: ${order.name}\nСтатус: ${getStatusText(order.status)}`;
            let latlng = L.latLng(order.truck.location.latitude, order.truck.location.longitude);
            let carIcon = L.icon({
              iconSize: order.truck.icon.iconSize,
              iconAnchor: order.truck.icon.iconAnchor,
              iconUrl: order.truck.icon.iconUrl,
              popupAnchor: [0, -order.truck.icon.iconSize[1]]
            });

            this.markerObject = L.marker(latlng, {
              icon: carIcon,
              title: message,
              rotationAngle: order.truck.icon.iconAngle,
              rotationOrigin: 'center center'
            });
            this.markerObject.addTo(store.map).bindPopup(message);
            this.allJsonLayers.push(this.markerObject);
          } else {
            toast.error("Нет данных телеметрии для а/м " + order.truck.number, {
              autoClose: 3000,
            });
          }
          var latlngDelivery = L.latLng([order.deliveryLocation.latitude, order.deliveryLocation.longitude]);
          var latlngLoading = L.latLng([order.loadingLocation.latitude, order.loadingLocation.longitude]);
          this.markerFinish = L.marker(latlngDelivery, {icon: this.finishIcon});
          this.markerLoading = L.marker(latlngLoading, {icon: this.loadingIcon});
          this.allJsonLayers.push(this.markerFinish);
          this.allJsonLayers.push(this.markerLoading);
          this.markerFinish.addTo(store.map);
          this.markerLoading.addTo(store.map);

          var zoom = store.map.getZoom();
          if (zoom < 9) {
            zoom = 9;
          }
          if (order.truck.number != null && order.truck.location != null) {
            // анимация фокуса на машину или на флажек
            store.map.flyTo([order.truck.location.latitude, order.truck.location.longitude], zoom, {
              duration: 1,
              easeLinearity: 0.25,
            });
          } else {
            store.map.flyTo(latlngDelivery, zoom, {
              duration: 1,
              easeLinearity: 0.25,
            });
          }

          // // расчет маршрута и времени (сторонний сервис)
          this.routePolyline = L.polyline(this.decodePolylineGeometry(responseData.routeGeometry), {color: '#000'});
          this.routePolyline.truckplate = order.truck.number;
          this.routePolyline.type = 'route';
          this.routePolyline.addTo(store.map);
          this.allJsonLayers.push(this.routePolyline);
        }
      } catch (error) {
        this.error = error.message || "Ошибка при построении маршрута";
        console.error("Error show route:", error);
      } finally {
        this.loading = false;
      }
    },

    decodePolylineGeometry(str, precision) {
        let index = 0;
        let lat = 0;
        let lng = 0;
        const coordinates = [];
        let shift = 0;
        let result = 0;
        let byte = null;
        let latitude_change;
        let longitude_change;
        const factor = Math.pow(
            10,
            precision !== undefined && Number.isInteger(precision) ? precision : 5
        );

        while (index < str.length) {
            byte = null;
            shift = 0;
            result = 0;

            do {
                byte = str.charCodeAt(index++) - 63;
                result |= (byte & 0x1f) << shift;
                shift += 5;
            } while (byte >= 0x20);

            latitude_change = result & 1 ? ~(result >> 1) : result >> 1;

            shift = result = 0;

            do {
                byte = str.charCodeAt(index++) - 63;
                result |= (byte & 0x1f) << shift;
                shift += 5;
            } while (byte >= 0x20);

            longitude_change = result & 1 ? ~(result >> 1) : result >> 1;

            lat += latitude_change;
            lng += longitude_change;

            coordinates.push([lat / factor, lng / factor]);
        }

        return coordinates;
    }
  },
});
